'use strict';

var cart = require('../cart/cart');

var updateMiniCart = true;
/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessageAndRemoveFromCart(data) {
    $.spinner().stop();
    var status = data.success ? 'alert-success' : 'alert-danger';

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append('<div class="add-to-wishlist-messages "></div>');
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 1500);
/*     var $targetElement = $('a[data-pid="' + data.pid + '"]').closest('.product-info').find('.remove-product');
    var itemToMove = {
        actionUrl: $targetElement.data('action'),
        productID: $targetElement.data('pid'),
        productName: $targetElement.data('name'),
        uuid: $targetElement.data('uuid')
    };
    $('body').trigger('afterRemoveFromCart', itemToMove);
    setTimeout(function () {
        $('.cart.cart-page #removeProductModal').modal();
    }, 2000); */
}

function removeInlineStyle(property, element) {
    $(element).attr('style', function (i, style) {
        var regex = property + '[^;]+;?';
        var re = new RegExp(regex, 'g');
        return style && style.replace(re, '');
    });
}

module.exports = function () {
    cart();
    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $('.minicart').on('mouseenter focusin touchstart minicart:show', function (event) {
        let eventType = event.type;
        if (eventType === 'minicart:show') {
            $('html, body').animate({ scrollTop: 0 });
        }
        if (!$('.minicart .popover').hasClass('show')) {
            $('.minicart .popover').removeClass('minicart__custom-popover');
        }
        if ($('.search:visible').length === 0) {
            return;
        }
        $(this).addClass('close-minicart');
        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            if (!updateMiniCart && eventType !== 'minicart:show') {
                $('.minicart .popover').addClass('show');
                return;
            }

            $('.minicart .popover').addClass('show');
            $('.minicart .popover').spinner().start();
            $.get(url, function (data) {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(data);
                if (eventType === 'minicart:show') {
                    $('.modal-background').show();
                }
                updateMiniCart = false;
            });
        }
    });
    $('body').on('click', function (e) {
        if (event && event.target && $(event.target).closest('.minicart .popover').length === 0) {
            if (e.type === 'mouseenter' && !$('.minicart .popover').hasClass('minicart__custom-popover')) {
                $('.minicart .popover').removeClass('show');
            } else if (e.type === 'click') {
                $('.minicart .popover').removeClass('show');
                removeInlineStyle('display', '.modal-background');
            }
        }
    });
    $('body').on('click', '.mini-cart__close-js', function (e) {
        if ($('.minicart').has(e.target).length > 0) {
            $('.minicart .popover').removeClass('show');
            removeInlineStyle('display', '.modal-background');
        }
    });

    $('body').on('keyup', function (event) {
        if (event.keyCode == 27 && $('.minicart .popover').hasClass('show')) {
            $('.minicart .popover').removeClass('show');
            removeInlineStyle('display', '.modal-background');
        }
    });

    $('.minicart').on('mouseleave focusout', function (event) {
        if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0) ||
            (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity')) ||
            $('body').hasClass('modal-open')) {
            event.stopPropagation();
            return;
        }
        if (event.type !== 'mouseleave') {
            $('.minicart .popover').removeClass('show').removeClass('minicart__custom-popover');
            removeInlineStyle('display', '.modal-background');
        } else if (!$('.minicart .popover').hasClass('minicart__custom-popover')) {
            $('.minicart .popover').removeClass('show');
        }
    });
    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
    });

    $('body').on('click', '.product-move .move:not(.remove-product)', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var pid = $(this).data('pid');
        var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
        var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }
        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            },
            success: function (data) {
                displayMessageAndRemoveFromCart(data);
            },
            error: function (err) {
                displayMessageAndRemoveFromCart(err);
            }
        });
    });
};